export const INITIALIZE_SYSTEM = (state, initialized) => {
    state.system.initialized = initialized
}

export const setMainContentArea = (state, mainContentArea) => {
    state.mainContentArea = mainContentArea
}

export const SET_WINDOW_DIMENSIONS = (state, { width = 0, height = 0 }) => {
    state.dimensions.window.width = width
    state.dimensions.window.height = height
}

export const SET_SHOW_CHANGELOG = (state, showChangelog) => {
    state.showChangelog = showChangelog
}